import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const CircleInfoIcon = ({
  color = 'black',
  width = 20,
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-20.000000, -20.000000)">
          <g transform="translate(20.000000, 20.000000)">
            <circle id="Back" cx="10" cy="10" r="10" />
            <path
              d="M10,0 C15.5228475,0 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 C4.4771525,20 0,15.5228475 0,10 C0,4.4771525 4.4771525,0 10,0 Z M10,1.5 C5.30557963,1.5 1.5,5.30557963 1.5,10 C1.5,14.6944204 5.30557963,18.5 10,18.5 C14.6944204,18.5 18.5,14.6944204 18.5,10 C18.5,5.30557963 14.6944204,1.5 10,1.5 Z"
              id="Border"
              fill={getSemanticTextColor(color)}
            />
            <path
              d="M10.0055866,13 C10.5977654,13 10.9888268,13.4065934 11,14 C11,14.5714286 10.6089385,15 10.0055866,15 L10.0055866,15 L9.99441341,15 C9.40223464,15 9,14.5714286 9,14 C9,13.4065934 9.41340782,13 10.0055866,13 Z M10,5.5 C10.5522847,5.5 11,5.94771525 11,6.5 L11,6.5 L11,10.5 C11,11.0522847 10.5522847,11.5 10,11.5 C9.44771525,11.5 9,11.0522847 9,10.5 L9,10.5 L9,6.5 C9,5.94771525 9.44771525,5.5 10,5.5 Z"
              id="information"
              fill={getSemanticTextColor(color)}
              transform="translate(10.000000, 10.250000) scale(1, -1) translate(-10.000000, -10.250000) "
            />
          </g>
        </g>
      </g>
    </svg>
  </DefaultIconWrapper>
);
